module.exports = __webpack_public_path__ + "img/xmly.dd5e949a.png";